<script>
import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'TemplateLabel',

    functional: true,

    props: {
        template: {type: Object, required: true},
        hideIcon: {type: Boolean},
        largeIcon: {type: Boolean},
    },

    render(createElement, {props, data, parent}) {
        const iconClass = 'fas fa-fw fa-pencil-ruler' + (props.largeIcon ? ' fa-lg' : '');

        data.props = {
            item: props.template,
            hideIcon: props.hideIcon,
            iconClass: iconClass,
            none: parent.$t('templates.nil'),
        };

        return createElement(DataLabel, data);
    },
};
</script>
